/* eslint-disable @typescript-eslint/no-explicit-any */
export function isMobile() {
	const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
	return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
}